import '../Styles/Footer.css'

const Footer = () => {
    return(
        <footer data-cy='footer'>
            <p>Crossing Companion - By Colgan Meanor</p>
            <a href='https://github.com/colganmeanor'>GitHub</a>
            <a href='https://www.linkedin.com/in/colgan-meanor/'>LinkedIn</a>
            <p>Data and Icons Courtesy of <a href='http://acnhapi.com'>acnhapi.com</a></p>
        </footer>
    )
}

export default Footer